import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "mt-2"
};
const _hoisted_2 = {
  class: "row mb-2"
};
const _hoisted_3 = {
  class: "col-12 text-left fw-extra-bold fsi-16"
};
const _hoisted_4 = {
  class: "row"
};
const _hoisted_5 = {
  class: "col-12 mb-3 mt-2"
};
const _hoisted_6 = {
  class: "row mt-2"
};
const _hoisted_7 = {
  class: "col-12"
};
const _hoisted_8 = {
  class: "pl-4 pr-4"
};
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "fw-medium fsi-14 d-flex align-items-center mb-2",
  style: {
    "line-height": "1.6"
  }
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "mr-1 fw-bold fsi-16"
}, "Original Beneficiary")], -1);
const _hoisted_10 = {
  class: "fsi-14 d-flex align-items-center"
};
const _hoisted_11 = {
  class: "fw-medium",
  style: {
    "width": "80px",
    "color": "#787A9B"
  }
};
const _hoisted_12 = {
  class: "fw-bold"
};
const _hoisted_13 = {
  class: "fsi-14 d-flex align-items-center"
};
const _hoisted_14 = {
  class: "row mt-2"
};
const _hoisted_15 = {
  class: "col-12"
};
const _hoisted_16 = {
  class: "pl-4 pr-4"
};
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", {
  class: "fw-medium fsi-14 d-flex align-items-center mb-2",
  style: {
    "line-height": "1.6"
  }
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "mr-1 fw-bold fsi-16"
}, "Original Owner")], -1);
const _hoisted_18 = {
  class: "fsi-14 d-flex align-items-center"
};
const _hoisted_19 = {
  class: "fw-medium",
  style: {
    "width": "80px",
    "color": "#787A9B"
  }
};
const _hoisted_20 = {
  class: "fsi-14 d-flex align-items-center"
};
const _hoisted_21 = {
  class: "row mt-4"
};
const _hoisted_22 = {
  class: "col-lg-6 col-12"
};
const _hoisted_23 = {
  class: "pl-2 pr-2"
};
const _hoisted_24 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_25 = {
  class: "mr-1"
};
const _hoisted_26 = {
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_27 = {
  class: "fw-bold fsi-24"
};
const _hoisted_28 = {
  class: "row mt-lg-3 mt-4"
};
const _hoisted_29 = {
  class: "col-lg-6 col-12"
};
const _hoisted_30 = {
  class: "pl-2 pr-2"
};
const _hoisted_31 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_32 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_33 = {
  class: "fw-bold fsi-24"
};
const _hoisted_34 = {
  class: "fw-medium fs-12"
};
const _hoisted_35 = {
  class: "col-lg-6 col-12 mt-lg-0 mt-4"
};
const _hoisted_36 = {
  class: "pl-2 pr-2"
};
const _hoisted_37 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_38 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_39 = {
  class: "fw-bold fsi-24"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_RadioBtn = _resolveComponent("RadioBtn");
  const _component_Tip = _resolveComponent("Tip");
  const _component_Tooltip = _resolveComponent("Tooltip");
  const _component_NextBtnGroup = _resolveComponent("NextBtnGroup");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('Onboarding.Please select the role to delegate')), 1)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_RadioBtn, {
    tabs: ['Owner', 'Beneficiary'],
    modelValue: $options.radio1,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $options.radio1 = $event)
  }, null, 8, ["modelValue"])])]), $options.nodeInfo.owner !== $options.nodeInfo.beneficiary ? (_openBlock(), _createBlock(_component_Tip, {
    key: 0,
    level: "error"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('Onboarding.Address')) + ":", 1), _createElementVNode("div", _hoisted_12, _toDisplayString($options.nodeInfo['beneficiary']), 1)]), _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('Onboarding.There can be no other beneficiaries')), 1)])])])]),
    _: 1
  })) : _createCommentVNode("", true), $options.nodeInfo.owner === $options.nodeInfo.beneficiary ? (_openBlock(), _createBlock(_component_Tip, {
    key: 1
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_hoisted_17, _createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('Onboarding.Address')) + ":", 1), _createElementVNode("div", {
      class: "fw-bold link-text-ordinary",
      onClick: _cache[1] || (_cache[1] = $event => $options.gotoAddress($options.nodeInfo[$options.radio1.toString().toLowerCase()], _ctx.$i18n.locale))
    }, _toDisplayString($options.nodeInfo[$options.radio1.toString().toLowerCase()]), 1)]), _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('Onboarding.AddressTips1')), 1)])])])]),
    _: 1
  })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createElementVNode("span", _hoisted_25, [_createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t('Onboarding.Available Borrowing')), 1)])]), _createElementVNode("div", _hoisted_27, _toDisplayString($options.formatPrice($options.nodeInfo[$data.radio1MapVar[$options.radio1]].availableBorrowingAmount)) + " FIL ", 1)])])]), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [_createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t('Onboarding.Maximum Debt Ratio')), 1)]), _createElementVNode("div", _hoisted_33, _toDisplayString($options.formatPrice($options.nodeInfo[$data.radio1MapVar[$options.radio1]].maxDebtRatio * 100, 1)) + " %", 1), _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.$t('Onboarding.Maximum Leverage')) + ": " + _toDisplayString(parseFloat($options.nodeInfo[$data.radio1MapVar[$options.radio1]].maximumLeverage).toFixed(2)) + "x ", 1)])]), _createElementVNode("div", _hoisted_35, [_createElementVNode("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, [_createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.$t('Onboarding.LiqThreshold')), 1), _createVNode(_component_Tooltip, null, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Onboarding.LiqThreshold Tips')), 1)]),
    _: 1
  })]), _createElementVNode("div", _hoisted_39, _toDisplayString($options.formatPrice($options.nodeInfo[$data.radio1MapVar[$options.radio1]].LiqThreshold * 100, 1)) + " %", 1)])])]), $options.nodeInfo.owner === $options.nodeInfo.beneficiary ? (_openBlock(), _createBlock(_component_NextBtnGroup, {
    key: 2,
    onNext: $options.next,
    onPre: $options.pre
  }, null, 8, ["onNext", "onPre"])) : _createCommentVNode("", true)]);
}